import { Container, Point } from 'pixi.js';
import { Card } from 'components/Card';
import { CardPlace, GamePlace } from 'constants/cards';
import { SolitaireGame } from './SolitaireGame';
import { MonoBehavior } from './core/monoBehavior';

export type Move = {
    list: string[];
    from: CardPlace;
    cardToActivate?: Card;
    cardToHide?: Card;
    target: GamePlace;
};

export class GameBoardPlace extends MonoBehavior {
    container: Container;
    cards: Card[];
    index: number;
    game: SolitaireGame;
    gamePlace: GamePlace;
    constructor(game: SolitaireGame, index: number, type: GamePlace) {
        super();
        this.index = index;
        this.gamePlace = type;
        this.game = game;
        this.container = new Container();
        game.gameContainer.addChild(this.container);
        this.cards = [];
    }
    getLastMoveGroup(): Card[] {
        if (this.cards.length) return [this.cards[this.cards.length - 1] as Card];
        return [];
    }
    getNextMovingGroup(): Card[] {
        return [];
    }
    removeCard(removeCard: Card) {
        this.cards = this.cards.filter((c) => c?._id !== removeCard._id);
    }

    get length() {
        return this.cards.length;
    }
    get isEmpty() {
        return this.cards.length === 0;
    }
    get lastCard() {
        return this.cards.length ? this.cards[this.cards.length - 1] as Card : null;
    }
    getCard() {
        return this.cards.pop();
    }
    spliceCard(card: Card, order: number) {
        this.cards.splice(order, 0, card);
    }
    addCard(card: Card) {
        this.cards.push(card);
    }
    destroy(): void {
        super.destroy();
        while (this.container.children.length) {
            this.container.removeChild(this.container.children[0]);
        }
    }

    get hasHiddenCards() {
        return this.cards.some((card) => !card?.visible);
    }
    getNextCardPosition() {
        return new Point(this.container.x, this.container.y);
    }
    refresh() {}
    resize() {}
}
